/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface AppMarketingData {
    /** min length: 0, max length: 64 */
    appsflyer_id?: string;
    /** min length: 0, max length: 255 */
    singular_id?: string;
    /** min length: 0, max length: 255 */
    advertising_id?: string;
    /** min length: 0, max length: 255 */
    device_os_version?: string;
    /** min length: 0, max length: 255 */
    app_version?: string;
    /** min length: 0, max length: 255 */
    firebase_instance_id?: string;
    /** min length: 0, max length: 255 */
    idfv?: string;
}
